import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'

export type SpinnerLoadingProps = {
    size?: number
    thickness?: number
    color?: string
    fullScreen?: boolean
}

const SpinnerLoading = ({ size = 60, thickness = 4, color = '#003B6F', fullScreen = true }: SpinnerLoadingProps = {}) => {
    const spinner = <CircularProgress size={size} thickness={thickness} sx={{ color }} data-testid="spinner-loading-circular-progress" />

    if (!fullScreen) return spinner

    return (
        <Stack
            sx={{
                minHeight: 'calc(100vh - 200px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
            data-testid="spinner-loading-stack">
            <Box data-testid="spinner-loading-box">{spinner}</Box>
        </Stack>
    )
}

export default SpinnerLoading
